<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-05 18:23:47
 * @LastEditors: yuka
 * @LastEditTime: 2019-08-08 17:43:12
 * @Description: 审核记录
 -->

<template>
  <div>
    <div class="check-record-wrapper">
      <template v-if="imgList.length > 0">
        <img :src="item" alt="" srcset="" v-for="(item, index) in imgList" :key="index" />
      </template>
      <template v-else>
        <div class="no-data">
          暂无数据
        </div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: 'check-record',
  data() {
    return {
      checkList: {},
      title: '审核记录'
    };
  },
  computed: {
    imgList() {
      return this.checkList;
    }
  },
  created() {
    if (this.$route.params.flag === '1') {
      this.requestDetail();
    } else {
      this.requestNo1Detail();
      return;
    }
    this.requestDetail();
  },
  mounted() {
    // this.$eventBus.$emit('listBarTitle', this.title);
  },
  methods: {
    async requestDetail() {
      const res = await this.$http.post('cg/commonRequest', {
        method: 'project.pc.detail',
        projectid: this.$route.params.id
      });
      if (res.code === 200) {
        const data = res.data;
        this.checkList = data.loanDta;
      }
    },
    // 鲸鱼一号
    async requestNo1Detail() {
      const res = await this.$http.post('/cg/commonRequest', {
        method: 'oproject.detail',
        projectid: this.$route.params.id
      });
      if (res.code === 200) {
        const data = res.data;
        this.checkList = data.applyRecord.audit_pic;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.check-record-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.4rem;
  img {
    display: block;
    width: 80%;
  }
  .no-data {
    min-height: 300px;
    line-height: 300px;
    font-size: 30px;
    text-align: center;
    color: #ccc;
  }
}
</style>
